import * as React from "react"

interface Props {
    icon: string
    label?: string
    title: string
}

export const ConfigWidget = ({ icon, title, label }: Props): JSX.Element => (
    <>
        <h3 className="tw-mr-2 is-dimmed">{icon}</h3>
        <div className="tw-flex-1">
            {!!label && <div className="label is-dimmed">{label}</div>}
            <div className="p">{title}</div>
        </div>
    </>
)
export default ConfigWidget
